import { NewButton, NewButtonSize, NewButtonVariant } from "@visiblethread/react-components";
import Flex from "components/Flex";
import { MessageSquarePlus, MessageSquareText } from "lucide-react";
import { func, number } from "prop-types";

import styles from "./CommentIconButton.module.scss";

const CommentIconButton = ({ commentCount = 0, onClick }) => {
  const hasComments = commentCount > 0;
  const LeftIcon = hasComments ? MessageSquareText : MessageSquarePlus;

  return (
    <div className={styles["comment_icon_button"]}>
      <NewButton
        variant={hasComments ? NewButtonVariant.parent : NewButtonVariant.gray}
        size={NewButtonSize.sm}
        onClick={onClick}
        aria-label={
          hasComments
            ? `View ${commentCount} comment${commentCount === 1 ? "" : "s"}`
            : "Add comment"
        }
        leftIcon={<LeftIcon size={16} />}
      />
      {hasComments && (
        <Flex
          justifyContent="center"
          className={styles["comment_icon_button__badge"]}
          aria-hidden="true"
        >
          {commentCount}
        </Flex>
      )}
    </div>
  );
};

CommentIconButton.propTypes = {
  commentCount: number,
  onClick: func.isRequired,
};

export default CommentIconButton;
